import styled from 'styled-components';

export const AlignDatePickers = styled.div`
  display: flex;
  gap: 8px;
  margin: 24px 0;
`;

export const AlignRow = styled.div`
  display: flex;
  gap: 4px;
`;

export const AlignButtons = styled.div`
  display: flex;
  gap: 8px;
  margin-top: 16px;
`;

export const AlignInformations = styled.div`
  display: flex;
  align-items: center;
`;
